module.exports = __webpack_public_path__ + "img/broker.38c7eee5.svg";